import React from 'react'
import { Typography } from '@mui/material'
import { TrainingCompaniesColumnType } from '@features/trainingCompanies/provider/TrainingCompaniesProvider'
import { getGridStringOperators } from '@mui/x-data-grid-pro'

export const addressColumnModel: TrainingCompaniesColumnType = {
  field: 'address',
  width: 200,
  filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains' || operator.value === 'equals'),
  renderCell: (params) => (
    <Typography variant="subtitle1" fontWeight={500}>{params.value}</Typography>
  )
}
